import { SxProps, Theme } from '@mui/material';

export const sxStyles: Record<string, SxProps<Theme>> = {
  mainContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 2,
    backgroundColor: '#f5f5f5',
  },
  card: {
    maxWidth: 400,
    width: '100%',
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    padding: 3,
  },
  welcomeText: {
    fontWeight: 'bold',
    textAlign: 'center',
    mb: 2,
  },
  link: {
    color: '#007bff',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

export const cssStyles = {
  logoStyle: {
    width: 150,
    marginBottom: 16,
  },
};
